import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getAmplitudeViewItemEventProperties} from "./get_amplitude_view_item_event_properties";

export interface IGetAmplitudeOfferSelectItemEventPropertiesParams {
    offer: IOfferBoxOffer;
    index: number;
}

export const getAmplitudeOfferSelectItemEventProperties = ({
    offer,
    index
}: IGetAmplitudeOfferSelectItemEventPropertiesParams): Record<string, string | number> => ({
    ...getAmplitudeViewItemEventProperties({
        offer: {
            id: offer.id,
            name: offer.name,
            type: offer.type,
            currency: offer.currency,
            vendor: offer.vendor,
            region: offer.region
        }
    }),
    index
});
import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getAmplitudeViewItemEventProperties} from "./get_amplitude_view_item_event_properties";

export interface IGetAmplitudeOfferSelectItemEventPropertiesParams {
    offer: IOfferBoxOffer;
    index: number;
}

export const getAmplitudeOfferSelectItemEventProperties = ({
    offer,
    index
}: IGetAmplitudeOfferSelectItemEventPropertiesParams): Record<string, string | number> => ({
    ...getAmplitudeViewItemEventProperties({
        offer: {
            id: offer.id,
            name: offer.name,
            type: offer.type,
            currency: offer.currency,
            vendor: offer.vendor,
            region: offer.region
        }
    }),
    index
});
